import { render, staticRenderFns } from "./ConstructionSubprojectsPortlet.vue?vue&type=template&id=67411b97&"
import script from "./ConstructionSubprojectsPortlet.vue?vue&type=script&lang=js&"
export * from "./ConstructionSubprojectsPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports